import { render } from "./VideoPlayer.vue?vue&type=template&id=05c48718"
import script from "./VideoPlayer.vue?vue&type=script&lang=js"
export * from "./VideoPlayer.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src931364701/src/github.com/DeepAngle/DDR-Atlas-Proto/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__